/**
 * Helper component to provide an HTML5 video
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// import third-party libraries
import _ from 'lodash';
import ReactJWPlayer from 'react-jw-player';

// import components
import Base from '../BaseComponent.js.jsx';

import * as userEventActions from '../../../modules/userEvent/userEventActions';

class Video extends Base {
  constructor(props) {
    super(props);
    this._bind(
      '_onComplete'
      , '_onPause'
      , '_onPlay'
      , '_onReady'
    )
  }

  shouldComponentUpdate(nextProps) {
    console.log(nextProps);
    return (
      // !_.isEqual(nextProps.videoSources, this.props.videoSources)
      // nextProps.videoSources
      true
      // || nextProps.playerId !== this.props.playerId
    )
  }

  _onReady(e) {
    // const player = window.jwplayer(this.playerId);
    // this.props.handleReady(playerId);
  }

  // NOTE: see https://github.com/micnews/react-jw-player for more events
  _onPlay(e) {
    // console.log("VIDEO IS PLAYING!", this.props.playerId)
    if(this.props.tracking) {
      this.props.dispatch(userEventActions.sendCreateUserEvent({
        ...this.props.tracking // should contain any relevant keys to save
        , eventType: "video"
        , eventAction: "play"
      }));
    }
    if(this.props.onPlay) {
      // pass on to parent in case it has callbacks too
      this.props.onPlay(e);
    }
  }

  _onPause(e) {
    if(this.props.tracking) {
      this.props.dispatch(userEventActions.sendCreateUserEvent({
        ...this.props.tracking // should contain any relevant keys to save
        , eventType: "video"
        , eventAction: "pause"
      }));
    }
    if(this.props.onPause) {
      this.props.onPause(e);
    }
  }

  _onComplete(e) {
    if(this.props.tracking) {
      this.props.dispatch(userEventActions.sendCreateUserEvent({
        ...this.props.tracking // should contain any relevant keys to save
        , eventType: "video"
        , eventAction: "finish"
      }));
    }
    if(this.props.onComplete) {
      this.props.onComplete(e);
    }
  }

  render() {
    // console.log("VIDEO RENDERING");
    const { adminPreview, handleReady, isAutoPlay, isMuted, playerId, videoSources } = this.props;
    // console.log(videoSources);
    // console.log('render Video.js');
    let playlist = [];
    videoSources.map((videoObject) => {
      let videoObj = {};
      // if(videoObject.src && videoObject.src.length > 0) {
        videoObj.sources = videoObject.sources;
      // }
      if(videoObject.posterUrl) {
        videoObj.image = videoObject.posterUrl;
      }
      // videoObj.type = videoObject.type;
      videoObj.tracks = videoObject.tracks;
      playlist.push(videoObj);
    });
    console.log(playlist)
    let jwScript = 'https://content.jwplatform.com/libraries/JKJ2bwkR.js';
    // console.log(videoSources)
    if(videoSources[0] && videoSources[0].sources && videoSources[0].sources[0] && videoSources[0].sources[0].file && videoSources[0].sources[0].file.length > 0) {
      // console.log("FOUND SOME VIDEO SOURCES TO RENDER");
      // if we have video and posterUrl - show videoObj
      return(
        <ReactJWPlayer
          className="react-jw-player-wrapper"
          image={videoSources[0].posterUrl && videoSources[0].posterUrl.length > 0 ? videoSources[0].posterUrl : ''}
          isAutoPlay={isAutoPlay}
          isMuted={isMuted}
          licenseKey="ARSuyOpWxi4Gq/3jm/hClEDvu5G7fswxhbY6rKg2jUo="
          onPlay={this._onPlay}
          onAutoStart={this._onPlay} // jwplayer treats the initial autoplay different from a 'play'
          onPause={this._onPause}
          onOneHundredPercent={this._onComplete}
          onReady={handleReady ? (e) => handleReady(playerId) : null}
          playerId={playerId}
          playerScript={jwScript}
          playlist={playlist}
        />
      )
    } else if(videoSources[0] && videoSources[0].posterUrl && videoSources[0].posterUrl.length > 0) {
      // else if no src but we have a posterUrl - show posterUrl img
      return(
        <img src={videoSources[0].posterUrl} style={{width:"100%"}} />
      )
    } else if(adminPreview) {
      return(
        <div className="-media-placeholder">
          <img src="/img/placeholders/placeholder-16-9.gif"/>
        </div>
      )
    } else {
      // else no posterUrl or src - return null for now (might eventually be a Pro-ficiency stub image)
      return null
    }
  }
}

Video.propTypes = {
  adminPreview: PropTypes.bool
  , handleReady: PropTypes.func // use to set jwPlayer controls from window
  , isAutoPlay: PropTypes.bool.isRequired
  , isMuted: PropTypes.bool
  , playerId: PropTypes.string.isRequired
  , videoSources: PropTypes.array.isRequired
  , onComplete: PropTypes.func
  , onPause: PropTypes.func
  , onPlay: PropTypes.func
}

Video.defaultProps = {
  adminPreview: false
  , handleReady: null
  , isMuted: true
}

export default connect()(Video);



// WEBPACK FOOTER //
// global/components/helpers/Video.js.jsx